/***
 Created by IntelliJ IDEA.
 User: xiexy
 Date: 2019/5/9
 ***/
import Vue from "vue";
import axios from "axios";
import router from "../router";
import { Toast, Dialog } from "vant";
import { commInHandle } from "../utils/cryptography";
// import {browser, removeStore} from "./index";
// import dsBridge from 'dsbridge';

const http = axios.create({
  timeout: 1000 * 35,
  withCredentials: false, //是否携带cookie信息
  headers: {
    "Content-Type": "application/json; charset=utf-8"
    // "Content-Type":
    //   "Application/x-www-form-urlencoded;charset=utf-8;application/json"
  }
});

/**
 * 请求拦截
 */
http.interceptors.request.use(
  config => {
    // if(config.url != '/frontEnd/BUSL/BUSL03') {
    Toast.loading({ message: "加载中...", duration: 0 });
    // }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

/**
 * 响应拦截
 */
http.interceptors.response.use(
  response => {
    Toast.clear();
    return response;
  },
  error => {
    switch (error.response.status) {
      case 400:
        Toast.fail(error.response.data);
        break;
      case 405:
        Toast.fail("http请求方式有误");
        break;
      case 500:
        Toast.fail("服务器出了点小差，请稍后再试");
        break;
      case 501:
        Toast.fail("服务器不支持当前请求所需要的某个功能");
        break;
    }
    return Promise.reject(error);
  }
);

/**
 * post请求地址处理
 */
//  /exam/exam-one

http.baseURL = url => {
  if (process.env.NODE_ENV == "development") {
    //开发环境
    if (url.indexOf("/api/") > -1) {
      http.defaults.baseURL = "https://api.66mz8.com";
    } else {
        http.defaults.baseURL = "https://www.ccsmk.com/om_cc/interf";
      // http.defaults.baseURL = "https://ccsmk.com/om_hd/interf";
    //  http.defaults.baseURL = "https://ccsmk.com/om_t/interf";
    }
  } else if (process.env.NODE_ENV == "test") {
    //测试环境
    if (url.indexOf("/api/") > -1) {
      http.defaults.baseURL = "https://api.66mz8.com";
    } else {
       http.defaults.baseURL = "https://ccsmk.com/om_hd/interf";
     // http.defaults.baseURL = "https://ccsmk.com/om_t/interf";
    }
  } else if (process.env.NODE_ENV == "production") {
    //正式环境
    if (url.indexOf("/api/") > -1) {
      http.defaults.baseURL = "https://api.66mz8.com";
    } else {
      http.defaults.baseURL = "https://www.ccsmk.com/om_cc/interf";
    }
  }
};

/**
 * post请求数据处理
 * @param {*} data 数据对象
 * @param {*} type 处理方式0软算法1江南科友
 */
http.postData = (data = {}, type = 0) => {
  if (type == 1) {
    data = commInHandle.sign(data);
  } else if (type == 2) {
    data = data;
  } else {
    data = commInHandle.sign(commInHandle.encrypt(data));
  }
  return JSON.stringify(data);
};

/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 * @param {*} type 处理方式0软算法1江南科友
 */
http.postRequest = (url, data = {}, type = 0) => {
  http.baseURL(url);
  return new Promise((resolve, reject) => {
    http
      .post(url, http.postData(data, type))
      .then(res => {
        resolve(res.data);
      })
      .catch(err => {
        reject(err.data);
      });
  });
};

Vue.prototype.$http = http;



// WEBPACK FOOTER //
// ./src/utils/http-request.js